module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white-c64f7e35dd83f51fcb0f0eab253857a9.png";